import React from 'react';

import { Button, Dialog, H1, Text } from '@betterment/samba-react';

const CashReserveFirstFeeAssessmentExplanationModal: React.FC<{
  isOpen: boolean;
  closeHandler: () => void;
}> = ({ isOpen, closeHandler }) => {
  return (
    <Dialog open={isOpen} overlay="default" onOpenChange={closeHandler}>
      <Dialog.Content
        css={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: '640px',
          p: 'space.400',
          overflow: 'auto',
          pb: 'space.0',
        }}
      >
        <Dialog.Title asChild={true}>
          <H1 variant="title300">Cash accounts restrictions</H1>
        </Dialog.Title>

        <Dialog.Description />

        <Text variant="text50" color="text" css={{ marginTop: '12px' }}>
          <ul>
            <li>Standard 401(k) fees are not eligible for assessment from cash accounts.</li>
            <li>Fees for individual investing accounts may only be assessed from cash accounts that share an owner.</li>
            <li>
              Fees for investing trust accounts may only be assessed from cash trust accounts that share a taxpayer
              identification number.
            </li>
          </ul>
        </Text>
        <Button
          data-testid="modal-close-button"
          variant="solidSecondary"
          css={{ width: '90px', mb: 'space.400' }}
          onClick={closeHandler}
        >
          Close
        </Button>
      </Dialog.Content>
    </Dialog>
  );
};

export default CashReserveFirstFeeAssessmentExplanationModal;
